import React from "react";
import { useTranslation } from "react-i18next";
import MobileAppLayout from "../../../layouts/MobileAppLayout";
import { GameHero } from "../../../components/game";
import AttendanceReportPanel from "../../../components/reports/AttendanceReportPanel";

/**
 * Rapoarte, pentru antrenor.
 *
 * One report for now — prezența — so the page is the report rather than a menu
 * leading to it. When a second kind arrives it becomes a list; until then, a
 * tab bar with one tab is furniture.
 */
export default function AppCoachReports() {
  const { t } = useTranslation();

  return (
    <MobileAppLayout>
      <div className="pb-6">
        <GameHero flow className="px-4 pt-3 pb-4 rounded-br-3xl">
          <h1 className="text-xl font-extrabold">{t("coach.reports", "Rapoarte")}</h1>
          <p className="text-white/70 text-[13px] mt-0.5">
            {t("coach.reportsSubtitle", "Raport de prezență, pe lună și pe echipă")}
          </p>
        </GameHero>

        <div className="px-4 pt-5">
          <AttendanceReportPanel compact />
        </div>
      </div>
    </MobileAppLayout>
  );
}
